import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=d0fe878a"
import script from "./clientDetail.vue?vue&type=script&lang=js"
export * from "./clientDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports